import React, { useState } from 'react'
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';
import AddIcon from '@material-ui/icons/Add';
import { globalPostService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus } from '../../../utils_v2';
import { useSnackbar } from 'notistack';
import { GetApp } from '@material-ui/icons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export default function ImportTask({getResponseBack, slug}) {
    const [importTask, setImportTask] = useState({})
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [files,setFiles]= useState(null)
    const onFilesDrop = (file) => {
        setFiles(file);
    }
    const importTaskListFn =()=>{
        var formData = new FormData();
        formData.append('import_file',files[0]);
        globalPostService(`technical/project/${slug}/import-tasks/`, formData)
        .then(response=>{
            if(checkApiStatus(response)){
                getResponseBack()
                setImportTask({modal:false})
                enqueueSnackbar(response?.data?.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}})
            }
            else{
                enqueueSnackbar(response?.data?.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}})
            }
        })
    }
    const downloadSampleTemplate =()=>{
        window.open(`https://sparta-aims.ams3.cdn.digitaloceanspaces.com/media-dev/Sample_Template/Project_Tasks_Sample_Import.xlsx`)
    }
    return (
        <>
            <Button onClick={() => setImportTask({ modal: true })} color='primary' variant='outlined' size='small'><AddIcon color='primary' style={{ fontSize: '1.15rem' }} />Import Task List</Button>
            <Dialog
                open={importTask.modal}
                onClose={() => setImportTask({ modal: true })}
                maxWidth='lg'
            >
                <DialogTitle id="scroll-dialog-title">
                    Import Task List
                </DialogTitle>
                <DialogContent dividers={true} style={{ width: "400px", paddingTop: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                        <span> Refer the sample template </span>
                        <Button style={{ fontFamily: '"Conv_IBMPlexSans-Bold"', fontWeight: '700' }} size='small' color='primary' variant='text' aria-controls="simple-menu" aria-haspopup="true" onClick={downloadSampleTemplate} endIcon={<ArrowDropDownIcon fontSize='small' />}> Download </Button>
                    </div>
                    <Grid container spacing={1}>
                        <Grid item md={12}>
                            <DropzoneArea
                                acceptedFiles={['.xlsx']}
                                filesLimit={1}
                                maxFileSize={10428800}
                                showPreviewsInDropzone={false}
                                useChipsForPreview={true}
                                showPreviews={true}
                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                dropzoneClass="drag-drop-cnt"
                                maxWidth="sm"
                                showAlerts={['info', 'error']}
                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                clearOnUnmount={true}
                                onChange={(files) => onFilesDrop(files)}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setImportTask({ modal: false })} color="primary" size='small' variant='outlined'>
                        Cancel
                    </Button>
                    <Button disabled={files?.length ? false :true} onClick={() => importTaskListFn()} color="primary" size='small' variant='contained'>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
